/* eslint-disable camelcase */
// ServiceSpecificationに基づいてFeatureFlagsを作成する関数を返します。
import { ServiceSpecification } from '@service_specification/specification_commonjs/stailer_service_specification/v1/service_specification_pb'
import { ProductCodeDisplayType, ProductCodePosition } from '~/models/partner_config'
import { ProductCode_ProductCodeType } from '@service_specification/specification_commonjs/stailer_service_specification/fulfillment/pick_pack/v1/product_code_pb'
import {
  DayBeforePicking_PaperPickingListSelecting,
  PaperPickingList_ProductCodePosition,
} from '@service_specification/specification_commonjs/stailer_service_specification/fulfillment/pick_pack/v1/picking_pb'
import { StailerPickPack } from '@service_specification/specification_commonjs/stailer_service_specification/fulfillment/pick_pack/v1/pick_pack_pb'

// ServiceSpecificationからStailerPickPackの設定を抽出します。
export function extractStailerPickPack(spec: ServiceSpecification): StailerPickPack | undefined {
  if (spec.fulfillment?.pickPack?.case === 'stailerPickPack') {
    return spec.fulfillment?.pickPack.value
  }

  return undefined
}

// パートナー設定のピックパックに関するFeatureFlagsを作成します。
export function createPartnerConfigFeatureFlagsPickPackPart(spec: ServiceSpecification) {
  const wantStailerPickPack = () => extractStailerPickPack(spec)
  const displayBarcodeInPickList = (): boolean => {
    return wantStailerPickPack()?.picking?.paperPickingList?.enableDisplayingBarcode === true
  }
  const displayProductCodeInPickList = (): boolean => {
    const position = wantStailerPickPack()?.picking?.paperPickingList?.productCodePosition
    return position !== undefined && position !== PaperPickingList_ProductCodePosition.UNSPECIFIED
  }
  return {
    get displayBarcodeInPickList(): boolean {
      return displayBarcodeInPickList()
    },
    get productCodeDisplayTypeInPickList(): ProductCodeDisplayType {
      if (!displayProductCodeInPickList()) {
        return 'none'
      }

      const codeType = wantStailerPickPack()?.productCode?.codeType
      switch (codeType) {
        case ProductCode_ProductCodeType.PRODUCT_ID:
          return 'productId'
        case ProductCode_ProductCodeType.SCAN_CODE:
          return 'scanCode'
        case ProductCode_ProductCodeType.UNSPECIFIED:
        default:
          return 'none'
      }
    },
    get productCodePositionInPickList(): ProductCodePosition {
      const position = wantStailerPickPack()?.picking?.paperPickingList?.productCodePosition
      switch (position) {
        case PaperPickingList_ProductCodePosition.UNDER_PRODUCT_NAME:
          return 'productNameColumn'
        case PaperPickingList_ProductCodePosition.RECORD_LINE_BOTTOM:
          return 'productCodeColumn'
        case PaperPickingList_ProductCodePosition.UNSPECIFIED:
        default:
          /// 未指定の場合displayProductCodeInPickListがfalseになるので実質表示されない
          return 'productNameColumn'
      }
    },
    get productCodeEmphasizedDigitInPickList() {
      const emphasizedDigit = wantStailerPickPack()?.productCode?.emphasizedDigit
      if (emphasizedDigit === undefined) {
        return 0
      }
      if (emphasizedDigit.case === 'specified') {
        return emphasizedDigit.value.digit
      }
      return 0
    },
    get displayProductCodeInPickList(): boolean {
      return displayProductCodeInPickList()
    },
    get preferDayBeforePicking(): boolean {
      const pickPack = wantStailerPickPack()
      return (
        pickPack?.picking?.dayBeforePicking.case === 'enableDayBeforePicking' &&
        pickPack?.picking?.dayBeforePicking.value.defaultPaperPickingListSelecting ===
          DayBeforePicking_PaperPickingListSelecting.NEXT_DAY
      )
    },
    get enableStailerTMS(): boolean {
      // NOTE:
      //  StailerTMSに関わるフラグ名だが、実態はピッキングリスト表示の制御のみ。
      const pickPack = wantStailerPickPack()

      // StailerのPickPackを使用している場合はtrue、それ以外(FrestaOrbisなど)はfalse
      return pickPack !== undefined
    },
  }
}
/* eslint-enable camelcase */
